
export const statusChipColor = (s: string) => {
    switch (s) {
        case 'In progress': return '#387E79';
        case 'New': return '#FED700';
        case 'Re-open': return '#FED700';
        case 'Draft': return '#116F9A';
        case 'Closed': return '#BCBEC0';
        case 'Closed w/o action': return '#BCBEC0';
        default: return '#FFFFFF';
    }
};

type Props = { status: string };

export default function StatusChip({ status }: Props) {
    const isWhiteText = status === 'Draft' || status === 'In progress';
    return (
        <span
            style={{
                fontFamily: 'CathaySans_bd',
                display: 'inline-block',
                padding: '4px 10px',
                borderRadius: 4,
                fontSize: '14px',
                background: statusChipColor(status),
                color: isWhiteText ? '#fff' : '#000',
                minWidth: 100,
                textAlign: 'center',
            }}
        >
            {status}
        </span>
    );
}